export const BTN_ACTIVE = 'filter__category-list__btn--active';
export const HIDDEN = 'hidden';
export const ITEM_FILTER_CLASSNAME = 'js-data-filter-item-category';
export const CARD_RECTO_CLASSNAME = 'anim-card-partenaire-recto';
export const CARD_VERSO_CLASSNAME = 'anim-card-partenaire-verso';
export const CARD_VERSO_VISIBLE = `${CARD_VERSO_CLASSNAME}--visible`;
export const CARD_RECTO_HIDDEN = `${CARD_RECTO_CLASSNAME}--hidden`;
export const FILTER_ITEM_PULL_UP = 'filter__item--pull-up';
